import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Gray_Btn from "../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import Success_Toster from "../../../../../../common/common_modal/success_toster/Success_Toster";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";
import {
  AllCalibratedBy,
  AllCalibrationStatus,
} from "../../../../../../features/admin/common/Slice";

const Instrument_Report_Filter = ({
  setShow,
  setSearchName,
  reportgenerate,
}) => {
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();
  // Redux selectors

  const all_calibration_status = useSelector(
    (state) => state.common.all_calibration_status,
  );
  const all_calibrated_by = useSelector(
    (state) => state.common.all_calibrated_by,
  );

  const permissions = useSelector((state) => state.auth.permissions);
  const havePermission = permissions?.includes(
    FixIDS.Instrument_management.Add,
  );

  const haveDownloadPermission = permissions?.includes(FixIDS.instrument_report.Report_Download);

  useEffect(() => {
    dispatch(AllCalibratedBy());
    dispatch(AllCalibrationStatus());
  }, [dispatch]);
  // Filter state
  const [unique_id, setUniqueId] = useState("");
  const [instrument_name, setInstrumentNameId] = useState("");
  const [calibration_status_id, setCalibrationStatusId] = useState("");
  const [calibrated_id, setCalibratedId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  // Auto hide toaster
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleSubmit = () => {
    setSearchName({
      unique_id: unique_id,
      instrument_name: instrument_name,
      calibration_status_id: calibration_status_id,
      calibrated_id: calibrated_id,
      start_date: startDate,
      end_date: endDate,
      year: selectedYear,
    });
    setSuccess(true);
  };

  const handleCancel = () => {
    setUniqueId("");
    setInstrumentNameId("");
    setCalibrationStatusId("");
    setCalibratedId("");
    setStartDate("");
    setEndDate("");
    setSelectedYear("");
    setSearchName({
      unique_id: "",
      instrument_name: "",
      calibration_status_id: "",
      calibrated_id: "",
      end_date: "",
      start_date: "",
      year: "",
    });
    setSuccess(false);
  };

  const startYear = 2026;
  const currentYear = new Date().getFullYear();

  const years = [];
  for (let i = startYear; i <= currentYear; i++) {
    years.push(i);
  }

  return (
    <section className="Sample_Report_Filter">
      <div className="row me-0 ms-0">
        <div className="col-lg-10">
          <div className="common_filter_div">
            <div className="row">
              <div className="col-xxl-9 col-xl-9 col-lg-12 col-md-12">
                <Form className="form_div">
                  <div className="row g-1">
                    {/* Search By */}
                    <div className="col-xl-4 col-lg-5 col-md-12 col-sm-12 col-12">
                      <div className="filter_div border_div">
                        <Form.Label>Search By:</Form.Label>
                        <Form.Group>
                          <div className="row g-1">
                            <div className="col-xxl-6 col-xl-12 col-md-12 col-sm-6 col-6">
                              <Form.Control
                                type="text"
                                placeholder="Instrument ID"
                                value={unique_id}
                                onChange={(e) => setUniqueId(e.target.value)}
                              />
                            </div>
                            <div className="col-xxl-6 col-xl-12 col-md-12 col-sm-6 col-6">
                              <Form.Control
                                type="text"
                                placeholder="Instrument Name"
                                value={instrument_name}
                                onChange={(e) =>
                                  setInstrumentNameId(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="filter_div">
                        <Form.Group>
                          <div className="row g-1">
                            <div className="col-xxl-3 col-xl-6 col-xxl-4 col-xl-6 col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Label>Start Date:</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Received Date"
                                value={startDate}
                                // onChange={(e) => setStartDate(e.target.value)}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  const parts = value.split("-");

                                  if (parts[0] && parts[0].length > 4) {
                                    parts[0] = parts[0].slice(0, 4);
                                    e.target.value = parts.join("-");
                                  }
                                  setStartDate(e.target.value);
                                }}
                              />
                            </div>

                            <div className="col-xxl-3 col-xl-6 col-xxl-4 col-xl-6 col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Label>End Date:</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Report Date"
                                value={endDate}
                                // onChange={(e) => setEndDate(e.target.value)}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  const parts = value.split("-");

                                  if (parts[0] && parts[0].length > 4) {
                                    parts[0] = parts[0].slice(0, 4);
                                    e.target.value = parts.join("-");
                                  }
                                  setEndDate(e.target.value);
                                }}
                              />
                            </div>
                            <div className="col-xxl-3 col-xl-6 col-xxl-4 col-xl-6 col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Label>Year</Form.Label>
                              <Form.Select
                                className="form-control"
                                value={selectedYear}
                                onChange={(e) =>
                                  setSelectedYear(e.target.value)
                                }
                              >
                                <option value="">Select Year</option>

                                {years.map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))}
                              </Form.Select>
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>

                    {/* Filter By */}
                    <div className="col-xl-8 col-lg-7 col-md-12 col-sm-12 col-12">
                      <div className="filter_div">
                        <Form.Label>Filter By:</Form.Label>
                        <Form.Group>
                          <div className="row g-1">
                            <div className="col-md-4 col-sm-6 col-12 mb-2">
                              <Form.Select
                                className="form-control"
                                value={calibration_status_id}
                                onChange={(e) =>
                                  setCalibrationStatusId(e.target.value)
                                }
                              >
                                <option value="">
                                  Select Calibration Status
                                </option>
                                {all_calibration_status.map((status) => (
                                  <option
                                    key={status.value}
                                    value={status.value}
                                  >
                                    {status.label}
                                  </option>
                                ))}
                              </Form.Select>
                            </div>
                            <div className="col-md-4 col-sm-6 col-12 mb-2">
                              <Form.Select
                                className="form-control"
                                value={calibrated_id}
                                onChange={(e) =>
                                  setCalibratedId(e.target.value)
                                }
                              >
                                <option value="">Select Calibrated By</option>
                                {all_calibrated_by.map((cal) => (
                                  <option key={cal.value} value={cal.value}>
                                    {cal.label}
                                  </option>
                                ))}
                              </Form.Select>
                            </div>
                            <div className="col-md-4 col-sm-12 col-12 mb-2">
                              {/* Extra field if needed */}
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>

              <div className="col-xxl-3 col-xl-3 col-lg-12 col-md-12">
                <div className="btns_holder">
                  <Gray_Btn btnText="Reset" onClick={handleCancel} />
                  <Black_Submit_Btn btnText="Search" onClick={handleSubmit} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-2 p-0">
          { haveDownloadPermission && <div
            className="add_sample_div"
            onClick={() => {
              reportgenerate();
            }}
          >
            <div className="add_img_div">
              <img src="/assets/images/other/report.png" className="add_img" />
            </div>
            <p className="inner_text">Generate Report</p>
          </div> }
        </div>
      </div>
    </section>
  );
};

export default Instrument_Report_Filter;
